/**
 * `/studio` — analytics, which is the studio's front page.
 *
 * The page is `pages/studio/analytics/`; the search key is its own, so a link to
 * `/studio?period=2026-07` compiles.
 *
 * `routeSearch` rather than the bare schema: `?period=nope` is a month somebody
 * guessed, and the front page of the portal is the last screen that should answer
 * a guess with an error boundary.
 */

import { createFileRoute } from '@tanstack/react-router'

import { AnalyticsPage, AnalyticsSearchSchema } from '../../pages/studio/analytics/AnalyticsPage.js'
import { routeSearch } from '../../search/useSearchState.js'

export const Route = createFileRoute('/studio/')({
  validateSearch: routeSearch(AnalyticsSearchSchema),
  component: AnalyticsPage,
})
